module.exports = __webpack_public_path__ + "img/charging-hub-disabled.a9c5c55c.png";